import { render } from "./widget.vue?vue&type=template&id=024b072c&scoped=true"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"

import "./widget.vue?vue&type=style&index=0&id=024b072c&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024b072c"]])

export default __exports__